export type OnboardingBodyFigurePartLabelKey =
  | "head"
  | "neck"
  | "trunk"
  | "leftShoulder"
  | "rightShoulder"
  | "leftUpperArm"
  | "rightUpperArm"
  | "leftElbow"
  | "rightElbow"
  | "leftForearm"
  | "rightForearm"
  | "leftWrist"
  | "rightWrist"
  | "leftHand"
  | "rightHand"
  | "leftHip"
  | "rightHip"
  | "leftUpperLeg"
  | "rightUpperLeg"
  | "leftKnee"
  | "rightKnee"
  | "leftLowerLeg"
  | "rightLowerLeg"
  | "leftAnkle"
  | "rightAnkle"
  | "leftFoot"
  | "rightFoot"
  | "upperBack"
  | "lowerBack"
  | "buttocks";

export interface OnboardingBodyFigureLabels {
  frontView: string;
  backView: string;
  rotate: string;
  rotateToBack: string;
  rotateToFront: string;
  left: string;
  right: string;
  parts: Record<OnboardingBodyFigurePartLabelKey, string>;
}

export const DEFAULT_ONBOARDING_BODY_FIGURE_LABELS: OnboardingBodyFigureLabels =
  {
    frontView: "Front",
    backView: "Back",
    rotate: "Rotate",
    rotateToBack: "Show back view",
    rotateToFront: "Show front view",
    left: "Left",
    right: "Right",
    parts: {
      head: "Head",
      neck: "Neck",
      trunk: "Chest and abdomen",
      leftShoulder: "Left shoulder",
      rightShoulder: "Right shoulder",
      leftUpperArm: "Left upper arm",
      rightUpperArm: "Right upper arm",
      leftElbow: "Left elbow",
      rightElbow: "Right elbow",
      leftForearm: "Left forearm",
      rightForearm: "Right forearm",
      leftWrist: "Left wrist",
      rightWrist: "Right wrist",
      leftHand: "Left hand",
      rightHand: "Right hand",
      leftHip: "Left hip",
      rightHip: "Right hip",
      leftUpperLeg: "Left upper leg",
      rightUpperLeg: "Right upper leg",
      leftKnee: "Left knee",
      rightKnee: "Right knee",
      leftLowerLeg: "Left lower leg",
      rightLowerLeg: "Right lower leg",
      leftAnkle: "Left ankle",
      rightAnkle: "Right ankle",
      leftFoot: "Left foot",
      rightFoot: "Right foot",
      upperBack: "Upper back",
      lowerBack: "Lower back",
      buttocks: "Buttocks",
    },
  };
